module.exports = __webpack_public_path__ + "static/media/study 210721.b10e47d8.png";